<template>
    <div class="education-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">学历信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <div v-for="(item, index) in educationInfoFormLoop" :key="index">
                            <el-row type="flex" justify="space-between">
                                <el-col :span="5" class="col">学历:</el-col>
                                <el-col :span="7" class="col-n col">{{ educationName[item.education - 1] }}</el-col>
                                <el-col :span="5" class="col">毕业院校:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.about_higher_institutions ?
                                    item.about_higher_institutions.name : '' }}</el-col>
                            </el-row>
                            <el-row type="flex" justify="space-between">
                                <el-col :span="5" class="col">毕业时间:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.graduation_time }}</el-col>
                                <el-col :span="5" class="col">所学专业:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.studied }}</el-col>
                            </el-row>
                        </div>
                    </div>
                    <div v-else>
                        <el-form ref="educationInfoForm" :model="educationInfoForm" label-width="125px" size="medium">
                            <div v-for="(item, index) in educationInfoFormLoop" :key="index"
                                style="border-bottom: 1px solid #eeeaea;margin-bottom: 0.2rem;">
                                <el-form-item label="学历">
                                    <el-select v-model="item.education" placeholder="请选择" style="width: 100%" clearable
                                        filterable size="medium">
                                        <el-option :value="1" label="初中">
                                            初中
                                        </el-option>
                                        <el-option :value="2" label="高中">
                                            高中
                                        </el-option>
                                        <el-option :value="3" label="中专">
                                            中专
                                        </el-option>
                                        <el-option :value="4" label="大专">
                                            大专
                                        </el-option>
                                        <el-option :value="5" label="本科">
                                            本科
                                        </el-option>
                                        <el-option :value="6" label="硕士">
                                            硕士
                                        </el-option>
                                        <el-option :value="7" label="博士">
                                            博士
                                        </el-option>
                                        <el-option :value="8" label="其他">
                                            其他
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="毕业院校">
                                    <el-select v-model="item.graduation_institution" placeholder="请选择" style="width: 100%"
                                        clearable filterable size="medium" remote reserve-keyword
                                        :remote-method="ysyMGetGraduationInstitution">
                                        <el-option v-for="item in ysyMGraduationInstitutionOptions" :key="item.id"
                                            :value="item.id" :label="item.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="毕业时间">
                                    <el-date-picker v-model="item.graduation_time" type="date" unlink-panels
                                        value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="所学专业">
                                    <el-input v-model.trim="item.studied" clearable></el-input>
                                </el-form-item>
                                <div style="text-align: right;margin-bottom:0.2rem;" v-if="index !== 0">
                                    <span style="color: #F56C6C;cursor: pointer" @click="delLoop(index)">
                                        <i class="el-icon-delete"></i>
                                        <span>删除本条</span>
                                    </span>
                                </div>
                            </div>
                            <div style="width: 100%;text-align: center;cursor: pointer;border: 1px dashed #ccc;height: 25px;border-radius: 8px;line-height: 25px;margin-bottom: 0.2rem;font-size: medium;"
                                @click="addEducationInfoFrom">
                                + 新增
                            </div>
                            <div style="text-align: center;width: 100%!important;">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'EducationInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            educationInfoForm: {},
            educationInfoFormLoop: [
                {
                    education: '',
                    graduation_institution: '',
                    graduation_time: '',
                    studied: ''
                }
            ],
            isEdit: false,
            adminuserId: '',
            adminuserName: '',
            educationName: ['初中', '高中', '中专', '大专', '本科', '硕士', '博士', '其他'],
        }
    },
    methods: {
        onSubmit() {
            this.$axios.put('api/api3_update_graduation_institution_info', {
                formData: this.educationInfoFormLoop,
                admin_user_id: this.adminuserId
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.educationInfoFormLoop = data.data
                    if (data.data.length === 0) {
                        this.educationInfoFormLoop = [
                            {
                                education: '',
                                graduation_institution: '',
                                graduation_time: '',
                                studied: ''
                            }
                        ]
                    }
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserEducationInfo(admin_user_id) {
            this.resetForm()
            this.ysyMGraduationInstitutionOptions = []
            this.ysyMAdminUserEducationInfoOptions = []
            this.ysyMGetGraduationInstitution()
            this.ysyMGetAdminUserEducationInfo(admin_user_id)
        },
        resetForm() {
            this.educationInfoFormLoop.map(item => {
                item.education = '',
                    item.graduation_institution = '',
                    item.graduation_time = '',
                    item.studied = ''
            })
        },
        addEducationInfoFrom() {
            this.educationInfoFormLoop.push({
                education: '',
                graduation_institution: '',
                graduation_time: '',
                studied: ''
            })
        },
        delLoop(no) {
            this.educationInfoFormLoop.splice(no, 1)
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserEducationInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserEducationInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.educationInfoFormLoop = n
                        if (n.length === 0) {
                            this.educationInfoFormLoop = [
                                {
                                    education: '',
                                    graduation_institution: '',
                                    graduation_time: '',
                                    studied: ''
                                }
                            ]
                        }
                    }
                }
            },
        },
    },
    computed: {
        // educationName() {
        //     let education_name_arr = ['本地城镇', '本地农村', '外地城镇(省内)', '外地农村(省内)', '外地城镇(省外)', '外地农村(省外)']
        //     return education_name_arr[this.educationInfoForm.residence_type - 1]
        // },
        // residence_type() {
        //     let residence_type_arr = ['本地城镇', '本地农村', '外地城镇(省内)', '外地农村(省内)', '外地城镇(省外)', '外地农村(省外)']
        //     return residence_type_arr[this.educationInfoForm.residence_type - 1]
        // },
        // political_outlook() {
        //     let political_outlook_arr = ['团员', '党员', '群众', '其他']
        //     return political_outlook_arr[this.educationInfoForm.political_outlook - 1]
        // },
        // marital_status() {
        //     let marital_status_arr = ['未婚', '已婚', '离异', '丧偶', '分居']
        //     return marital_status_arr[this.educationInfoForm.marital_status - 1]
        // }
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/EducationInfo.vue